// extracted by mini-css-extract-plugin
export default {"button":"FavoriteButton_button__2zmYR","text":"FavoriteButton_text__nlsWz"};